import { forwardRef, type Ref, type SVGProps } from "react";

function SvgChat(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fill="currentColor"
        d="M12 2.25a9.75 9.75 0 0 0-8.608 14.333l-1.064 3.192a1.5 1.5 0 0 0 1.897 1.897l3.193-1.064A9.75 9.75 0 1 0 12 2.25m0 18a8.24 8.24 0 0 1-4.13-1.107.75.75 0 0 0-.614-.063L3.75 20.25l1.17-3.506a.75.75 0 0 0-.063-.613A8.25 8.25 0 1 1 12 20.25"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgChat);
export default ForwardRef;
